import NextDashboard from './NextDashboard';

export default NextDashboard;
